import { Icon, IconName } from "@components/shared/Icon";
import classNames from "classnames";
import * as React from "react";

export interface CardProps {
  buttonTitle: string;
  title: string;
  icon: IconName;
  onClick?: (() => void) | null;
  children: React.ReactNode;
  copy: string;
  isLoading?: boolean;
  disabled?: boolean;
  isSelected?: boolean;
}

export const Card: React.FC<CardProps> = ({
  buttonTitle,
  title,
  icon,
  copy,
  onClick,
  children,
  isLoading,
  disabled,
  isSelected,
}) => {
  const hasChildren = React.Children.toArray(children).length > 0;

  return (
    <button
      type="button"
      title={buttonTitle}
      {...(onClick && { onClick })}
      disabled={disabled}
      className={classNames(
        "ancillary-card",
        isLoading && "ancillary-card--loading",
      )}
      // We are using inline styles here because
      // we don't want the cards to appear unstyled
      // before the CSS stylesheet loads.
      // This is important for this component since it
      // be on visible on the page when it loads.
      style={{
        cursor: "pointer",
        background: "transparent",
        color: "var(--GREY-900)",
        border: "solid 1px rgba(226, 226, 232, 1)",
        display: "flex",
        rowGap: "4px",
        padding: "20px",
        borderRadius: "8px",
        justifyContent: "space-between",
        flexWrap: "wrap",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        letterSpacing: "0em",
        transition:
          "border-color 0.3s var(--TRANSITION-CUBIC-BEZIER) background-color 0.3s var(--TRANSITION-CUBIC-BEZIER)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginBlock: "0",
          textAlign: "start",
          marginTop: "2px",
          columnGap: "12px",
          width: "100%",
        }}
      >
        <div>
          {isSelected ? (
            <Icon name="check" className="ancillary-card__selected-icon" />
          ) : (
            <Icon name={icon} />
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            width: "100%",
          }}
        >
          <p
            className="p1--semibold"
            style={{
              marginBlock: "0",
            }}
          >
            {title}
          </p>
          <div className="ancillary-card__children">
            {hasChildren ? (
              children
            ) : (
              <Icon
                name="expand_content"
                className="ancillary-card__expand-icon"
              />
            )}
          </div>
        </div>
      </div>
      <p
        className="p1--regular"
        style={{
          textAlign: "start",
          color: "var(--GREY-600)",
          marginLeft: "34px",
          marginBlock: "0",
        }}
      >
        {copy}
      </p>
    </button>
  );
};
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";